<template>
  <button
    :class="`px-4 rounded border-none
      font-cera-pro font-medium text-base leading-5 text-center
      items-center justify-center no-underline outline-none
      disabled:bg-light-grey disabled:text-white
      cursor-pointer disabled:cursor-not-allowed ${classes}`"
    :type="type"
    :disabled="disabled"
    @click="handleClickEvent($event)"
  >
    <div v-if="icon" class="flex items-center justify-center text-center">
      <sprite :id="icon" class="w-6 h-6 mr-2" />
      <slot />
    </div>
    <slot v-else />
  </button>
</template>

<script>
import events from "@/bl-events"
import Sprite from "@/shared/sprite"

export const BUTTON_VARIANTS = {
  "conversion": "bg-green text-midnight hover:bg-green-2 hover:text-midnight",
  "product-interaction": "bg-midnight text-white hover:bg-deep-black hover:text-white"
}

export default {
  name: "BButton",
  components: {
    Sprite
  },
  props: {
    variant: {
      type: String,
      default: "conversion",
      validator: (value) => {
        return Object.keys(BUTTON_VARIANTS).includes(value)
      }
    },
    icon: { type: String, default: null },
    eventCategory: { type: String, default: "body-20200305-cta" },
    eventName: { type: String, default: null },
    type: { type: String, default: "submit" },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    classes() {
      return `${BUTTON_VARIANTS[this.variant]} ${this.icon ? "py-2.5" : "py-3"}`
    }
  },
  methods: {
    handleClickEvent(event) {
      if (this.eventName) {
        events.track(this.eventCategory, "1-click", this.eventName)
      } else {
        events.track(this.eventCategory, "1-click")
      }

      this.$emit("click", event)
    }
  }
}
</script>
